import React from "react";
import { Form } from "react-bootstrap";
import "./_ReportVersionTile.scss";

export interface TileProps {
  id: string;
  children?: React.ReactNode;
  img?: string;
  format?: string;
  active?: string;
  onClick: (id: string) => void;
}

const ReportsVersionTile = ({ id, children, img, format, active, onClick }: TileProps) => {
  return (
    <div className={"nutrient-tile"} onClick={() => onClick(id)}>
      <div className={"nutrient-tile--overlay"}>
        {img && <img src={img} alt={format} />}
        <div className="overlay__title">{format}</div>
        {children}
      </div>
      <Form.Check
        type={"radio"}
        id={id}
        value={id}
        bsCustomPrefix={active === id ? "custom-control checked" : `custom-control`}
        checked={id === active}
        onChange={() => onClick(id)}
        onClick={() => onClick(id)}
        custom
      />
    </div>
  );
};

export default ReportsVersionTile;
